import { Badge } from '@tempo-io/sui-badge';
import { cn } from '@tempo-io/sui-class-utils';

export type ItemStatusBadgeProps = Omit<
  React.ComponentProps<typeof Badge>,
  'children' | 'color'
> & {
  color: string;
  label: string;
};

export const ItemStatusBadge = ({
  color,
  label,
  style,
  className,
  ...props
}: ItemStatusBadgeProps) => (
  <Badge
    {...props}
    className={cn('border-none', className)}
    style={{ color: '#fff', backgroundColor: `#${color}`, ...style }}
  >
    {label}
  </Badge>
);
